<template>
  <div class="VersionDifferent">
    <div class="version_tips">以下功能分别分布在：患者手机端，诊疗流程PAD/PC端，医生手机端，管理PC端 &nbsp;&nbsp;&nbsp;&nbsp;<img src="@/assets/img/version_star.png" style="width: 0.18rem;height: 0.18rem" alt="">&nbsp;&nbsp;说明需要设备支持
    </div>
    <div class="version_top_back flex_column">
      <div class="version_top version_top1 flex_row">
        <div class="top_item flex_column item_blue">
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">机构属性
            </div>
          </div>
        </div>
        <div style="flex: 1" class="top_item flex_column item_yellow">
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">眼健康公益</div>
          </div>
        </div>
        <div class="top_item flex_column item_pink">
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">非医疗机构</div>
          </div>
        </div>
        <div class="top_item flex_column top_item flex_column item_green">
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row top_item_inner_right">医疗机构</div>
          </div>
        </div>
      </div>

      <div class="version_top version_top2 flex_row">
        <div class="top_item flex_column item_blue">
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">模块</div>
          </div>
        </div>
        <div class="top_item flex_column item_blue">
          <div class="top_item_top flex_row flex_3">
            <div class="top_item_inner flex_row">功能清单</div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">初装费
            </div>
          </div>
        </div>
        <div class="top_item flex_column item_yellow">
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">公益版
            </div>
          </div>
          <div class="top_item_top flex_row flex_2">
            <div class="top_item_inner flex_row">健康科普/管理
            </div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">NA</div>
          </div>
        </div>
        <div class="top_item flex_column item_pink">
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">眼镜店</div>
          </div>
          <div class="top_item_top flex_row flex_2">
            <div class="top_item_inner flex_column">
              <span>门店运营</span>
              <span>前台中台</span>
            </div>
            <div class="top_item_inner flex_column">
              <span>标准管理</span>
              <span>后台</span>
            </div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">详见合同</div>
<!--            1.8万-->
            <div class="top_item_inner flex_row">NA</div>
          </div>
        </div>
        <div class="top_item flex_column item_pink">
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">视光中心</div>
          </div>
          <div class="top_item_top flex_row flex_2">
            <div class="top_item_inner flex_column">
              <span>中心运营</span>
              <span>前台中台</span>
            </div>
            <div class="top_item_inner flex_column">
              <span>定制管理</span>
              <span>后台</span>
            </div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">详见合同</div>
            <div class="top_item_inner flex_row">详见合同</div>
<!--            2.8万  6.8万-->
          </div>
        </div>
        <div class="top_item flex_column item_green">
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">眼科门诊
            </div>
          </div>
          <div class="top_item_top flex_row flex_2">
            <div class="top_item_inner flex_column">
              <span>门诊运营</span>
              <span>前台中台</span>
            </div>
            <div class="top_item_inner flex_column">
              <span>医疗管理</span>
              <span>后台</span>
            </div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row">详见合同</div>
            <div class="top_item_inner flex_row">详见合同</div>
<!--            5.8万 18万-->
          </div>
        </div>
        <div class="top_item flex_column item_green">
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row top_item_inner_right">互联网医院</div>
          </div>
          <div class="top_item_top flex_row flex_2">
            <div class="top_item_inner flex_column">
              <span>医院运营</span>
              <span>前台中台</span>
            </div>
            <div class="top_item_inner flex_column top_item_inner_right">
              <span>医疗管理</span>
              <span>后台</span>
            </div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner flex_row top_item_inner_right">详见合同</div>
<!--            60万-->
          </div>
        </div>
      </div>

      <div class="version_top version_top3 flex_row">
        <div class="top_item flex_column item_blue">
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">费用明细</div>
          </div>
        </div>
        <div class="top_item flex_column item_blue">
<!--          <div class="top_item_top flex_row ">-->
<!--            <div class="top_item_inner flex_row">设备数据集成</div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">AI处方</div>
          </div>
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">年费</div>
          </div>
        </div>
        <div class="top_item flex_column item_yellow">
<!--          <div class="top_item_top flex_row">-->
<!--            <div class="top_item_inner flex_row">NA-->
<!--            </div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">NA</div>
          </div>
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">0</div>
          </div>
        </div>
        <div class="top_item flex_column item_pink">
<!--          <div class="top_item_top flex_row">-->
<!--            <div class="top_item_inner flex_row">0.9元/条</div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">2元/份</div>
          </div>
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">NA</div>
          </div>
        </div>
        <div class="top_item flex_column item_pink">
<!--          <div class="top_item_top flex_row">-->
<!--            <div class="top_item_inner flex_row">0.9元/条</div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">5元/份</div>
          </div>
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">NA</div>
          </div>
        </div>
        <div class="top_item flex_column item_green">
<!--          <div class="top_item_top flex_row">-->
<!--            <div class="top_item_inner flex_row">0.9元/条</div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row">25元/份</div>
          </div>
          <div class="top_item_top flex_row">
            <div class="top_item_inner top_item_inner_bottom flex_row">NA</div>
          </div>
        </div>
        <div class="top_item flex_column item_green">
<!--          <div class="top_item_top flex_row">-->
<!--            <div class="top_item_inner flex_row top_item_inner_right">0.9元/条</div>-->
<!--          </div>-->
          <div class="top_item_top flex_row">
            <div class="top_item_inner flex_row top_item_inner_right">40元/份</div>
          </div>
          <div class="top_item_top flex_row flex_1">
            <div class="top_item_inner top_item_inner_bottom flex_row top_item_inner_right">NA</div>
          </div>
        </div>
      </div>
    </div>
    <div class="version_body">
      <div class="version_items" v-for="(item, index) in versionData">
        <div class="body_title flex_row">
          <div class="title_item flex_row">
            <div class="body_tag flex_row" v-show="item.show" @click="item.show = !item.show">-</div>
            <div class="body_tag flex_row" v-show="!item.show" @click="item.show = !item.show">+</div>
            <div class="body_info flex_row">{{item.title}}</div>
          </div>
          <div class="title_item"></div>
          <div class="title_item"></div>
          <div class="title_item"></div>
          <div class="title_item"></div>
        </div>
        <div class="version_item" v-show="item.show">
          <div class="item_left flex_row">
            {{item.title}}
          </div>
          <div class="item_right" v-show="item.show">
            <div class="body_content">
              <div class="body_items flex_row" v-for="(item1, index1) in item.contents" >
                <div class="body_item body_item2 flex_row" :class="index1 >= item.contents.length - 1 ? 'body_bottom': ''">{{item1.info}}</div>
                <div class="body_item flex_row" :class="[index1 >= item.contents.length - 1 ? 'body_bottom' : '', index2 >= item1.tags.length - 1 ? 'body_right' : '', index2 == 0 ? 'body_item2': '']" v-for="(item2, index2) in item1.tags">
                  <img v-show="item2 == 2 ? true: false" src="@/assets/img/version_tag.png" alt="">
                  <img v-show="item2 == 3 ? true: false" src="@/assets/img/version_star.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VersionDifferent",
  data() {
    return {
      versionData: [
        {
          title: '智能营销',
          show: true,
          contents: [
            {
              info: '智能选址',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '设计方案',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '设计图纸',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '营销策划',
              tags: [1,1,1,1,1,1,1,1,1]
            },
            {
              info: '营销管理',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '分销设计',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '分佣管理',
              tags: [1,1,1,1,2,1,2,2,1]
            },
          ]
        },
        {
          title: '会员管理',
          show: true,
          contents: [
            {
              info: '会员注册',
              tags: [2,1,2,1,2,1,2,2,1]
            },
            {
              info: '家庭账户',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '在线支付',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '流程进度',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '健康报告',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '分享分销',
              tags: [2,1,2,1,2,1,2,2,1]
            },
            {
              info: '积分管理',
              tags: [1,1,2,1,2,1,2,2,1]
            },
            {
              info: '卡券促销',
              tags: [1,1,1,1,2,1,2,2,1]
            }
          ]
        },
        {
          title: '筛查系统',
          show: true,
          contents: [
            {
              info: '智能筛查',
              tags: [1,1,1,1,3,1,3,3,1]
            },
            {
              info: '近防疾控',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '近防校园',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '近防监管',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '社区筛查',
              tags: [1,1,1,1,3,1,3,3,1]
            },
            {
              info: '筛查管理',
              tags: [1,1,1,1,2,1,2,2,1]
            },
            {
              info: '流量闭环',
              tags: [1,1,1,1,2,1,2,2,1]
            }
          ]
        },
        {
          title: '接诊预诊',
          show: true,
          contents: [
            {
              info: '问诊主诉',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '视力检查',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '基础检查',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '电脑验光',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '眼压检查',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '筛查对接',
              tags: [1,1,1,1,1,2,1,2,1]
            }
          ]
        },
        {
          title: '特检科室',
          show: true,
          contents: [
            {
              info: '裂隙灯检查',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '眼底检查',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '医学验光',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '框架试戴',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '视功能检查',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '检查结论',
              tags: [1,2,1,2,1,1,1,1,1]
            },
            {
              info: '眼底诊断',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '角膜地形图',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '眼生物测量',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '角膜内皮镜',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '泪膜检查',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '同视机',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '视野',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '像差分析仪',
              tags: [1,1,1,1,1,1,1,2,1]
            }
          ]
        },
        {
          title: '专家诊室',
          show: true,
          contents: [
            {
              info: '眼部诊断',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '视光诊断',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '视光方案',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '电子病历',
              tags: [1,1,1,1,1,2,1,2,1]
            },
          ]
        },
        {
          title: 'OK镜验配',
          show: true,
          contents: [
            {
              info: '角膜塑形镜',
              tags: [1,1,1,1,1,2,1,2,1]
            }
          ]
        },
        {
          title: '治疗训练',
          show: true,
          contents: [
            {
              info: '视觉训练',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '在线训练',
              tags: [1,1,1,2,1,2,1,2,1]
            }
          ]
        },
        {
          title: '框架定配',
          show: true,
          contents: [
            {
              info: '镜片价目册',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '镜框价目册',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '定制参数建模',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '3D打印镜框',
              tags: [1,2,1,2,1,2,1,2,1]
            }
          ]
        },
        {
          title: '结算中心',
          show: true,
          contents: [
            {
              info: '结算中心',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '进销存',
              tags: [1,1,1,1,1,2,1,2,1]
            }
          ]
        },
        {
          title: '眼病转诊',
          show: true,
          contents: [
            {
              info: '白内障',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '青光眼',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '屈光手术',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '干眼诊疗',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '眼底病',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '小儿斜弱视',
              tags: [1,1,1,1,1,2,1,2,1]
            }
          ]
        },
        {
          title: '健康管理中心',
          show: true,
          contents: [
            {
              info: '健康报告',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '电子病历',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: 'OK镜报告',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '训练报告',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '框架镜报告',
              tags: [1,2,1,2,1,2,1,2,1]
            }
          ]
        },
        {
          title: '门诊运营管理',
          show: true,
          contents: [
            {
              info: '门诊管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '营销管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '绩效管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '流程定制',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '顾客管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '智慧运营',
              tags: [1,1,1,2,1,1,1,2,1]
            },
            {
              info: '集团架构',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '排班管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '价目册',
              tags: [1,2,1,2,1,1,2,2,1]
            },
            {
              info: '推荐设置',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '销售管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
            {
              info: '订单管理',
              tags: [1,1,1,1,1,1,2,2,1]
            },
          ]
        },
        {
          title: '科普演示',
          show: true,
          contents: [
            {
              info: '眼科疾病',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '方案演示',
              tags: [2,1,1,2,1,2,1,2,1]
            },
            {
              info: '产品演示',
              tags: [2,2,1,2,1,2,1,2,1]
            }
          ]
        },
        {
          title: 'ERP管理',
          show: true,
          contents: [
            {
              info: '权限管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '操作日志',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '人力资源',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '客户管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '进货管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '零售管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '库存管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '财务管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '报表管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
          ]
        },
        {
          title: '连锁体系\n四级架构',
          show: true,
          contents: [
            {
              info: '总部架构',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '批发管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '分级结算',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '商品共享',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '加盟管理',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '统购平台',
              tags: [1,1,2,1,2,1,2,1,2]
            },
            {
              info: '连锁财务',
              tags: [1,1,2,1,2,1,2,1,2]
            }
          ]
        },
        {
          title: '智能CRM',
          show: true,
          contents: [
            {
              info: '预约挂号',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '叫号信息',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '我的支付',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '我的报告',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '智能随访',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '家庭医生',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '健康管理',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '我的分享',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '重要通知',
              tags: [1,2,1,2,1,2,1,2,1]
            },
            {
              info: '体检筛查',
              tags: [1,2,1,1,1,2,1,2,1]
            },
            {
              info: '视觉训练',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '自测问诊',
              tags: [1,2,1,2,1,2,1,2,1]
            }
          ]
        },
        {
          title: '远程诊疗',
          show: true,
          contents: [
            {
              info: '专家绩效',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '排班计划',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '预约管理',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '远程会诊',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '论文课题',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '患者管理',
              tags: [1,1,1,1,1,2,1,2,1]
            },
            {
              info: '差评管理',
              tags: [1,1,1,2,1,2,1,2,1]
            },
            {
              info: '远程诊疗',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '药房管理',
              tags: [1,1,1,1,1,1,1,2,1]
            },
          ]
        },
        {
          title: '眼科PACS',
          show: true,
          contents: [
            {
              info: '电脑验光',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '眼压',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '眼底诊断',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '眼生物测量',
              tags: [1,1,1,1,1,1,1,2,1]
            },
            {
              info: '角膜地形图',
              tags: [1,1,1,1,1,1,1,2,1]
            },
          ]
        },
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.VersionDifferent {
  margin: 0 auto;
  width: 90vw;
  .border_none {
    border: none;
  }
  .version_tips {
    width: 100%;
    background: #FFFFFF;
    margin: 5px 0;
    //line-height:  4vh;
    //height: 4vh;
    font-size: 0.18rem;
    z-index: 999;
    top: 0.5rem;
  }
  .version_top_back {
    height: 18vh;
    background: #FFFFFF;
    z-index: 999;
    width: 100%;
    box-shadow: 0px 0.04rem 0.23rem 0px rgba(11, 3, 6, 0.22);
    .version_top {
      width: 100%;
      .top_item {
        flex: 2;
        height: 100%;
        font-size: 0.16rem;
        .top_item_top {
          flex: 1;
          width: 100%;
          .top_item_inner {
            flex: 1;
            height: 100%;
            border-left: 0.01rem solid rgba(0,0,0,0.2);
            border-top: 0.01rem solid rgba(0,0,0,0.2);
          }
          .top_item_inner_right {
            border-right: 0.01rem solid rgba(0,0,0,0.2);
          }
          .top_item_inner_bottom {
            border-bottom: 0.01rem solid rgba(0,0,0,0.2);
          }
        }
        .flex_1 {
          flex: 1;
        }
        .flex_2 {
          flex: 2;
        }
        .flex_3 {
          flex: 3;
        }
      }
      .item_blue {
        border-right: none;
        background: rgba(11,155,218,0.22);
      }
      .item_yellow {
        border-right: none;
        background: rgba(255,241,0,0.22);
      }
      .item_pink {
        border-right: none;
        background: rgba(236,105,65,0.22);
      }
      .item_green {
        background: rgba(34,172,56,0.22);
      }
    }
    .version_top1 {
      flex: 1;
    }
    .version_top2 {
      flex: 4;
    }
    .version_top3 {
      flex: 3;
    }
  }
  .version_body {
    padding-bottom: 1rem;
    height: 70vh;
    overflow-y: auto;
    .version_items {
      .body_title {
        margin: 0.33rem 0 0.2rem;
        .title_item  {
          justify-content: flex-start;
          flex: 1;
          .body_tag {
            width: 0.23rem;
            height: 0.23rem;
            color: #B6B6B6;
            font-size: 0.18rem;
            border: 0.01rem solid #B6B6B6;
            border-radius: 50%;
          }
          .body_info {
            margin-left: 0.05rem;
            color: #0066FF;
            font-size: 0.18rem;
          }
        }
      }
      .version_item {
        display: flex;
        .item_left {
          flex: 2;
          border-left: 0.01rem solid #B6B6B6;
          border-top: 0.01rem solid #B6B6B6;
          border-bottom: 0.01rem solid #B6B6B6;
        }
        .item_right {
          flex: 12;
          .body_content {
            .body_items {
              .body_item {
                height: 0.45rem;
                flex: 1;
                font-size: 0.13rem;
                color: #696969;
                border-left: 0.01rem solid #B6B6B6;
                border-top: 0.01rem solid #B6B6B6;
                img {
                  width: 0.28rem;
                }
              }
              .body_item2 {
                flex: 2;
              }
              .body_bottom {
                border-bottom: 0.01rem solid #B6B6B6;
              }
              .body_right {
                border-right: 0.01rem solid #B6B6B6;
              }
            }
          }
        }
      }
    }
  }
}
</style>
